import packageModalPage from './view/packageModal.html';
import utils from 'utils';
import importResult from './view/importResult.html';
class orgListCtrl {
  constructor(
    $scope,
    $uibModal,
    logger,
    httpRequest,
    $location,
    initSortService,
    sweetalert,
    $rootScope,
    $state,
    Upload,
    $timeout
  ) {
    $scope.selectedOrgList = []
    $scope.userType = $rootScope.userInfo.user.userType;
    // 有缓存参数，从缓存中取所属机构id orgOwnership
    const orgOwnerShip = JSON.parse(localStorage.user_info).user.orgOwnership;
    if (JSON.parse(localStorage.user_info).org) {
      $scope.parentOrgId = JSON.parse(localStorage.user_info).org.parentOrgId;
    }
    $scope.userTypeOrgId = $scope.userType ? orgOwnerShip : 0;
    // 字典数据
    $scope.dictData = {};
    httpRequest
      .get_dictByTypeArr(
        '["status","effective_flag","taxplayer_type","department_no", "sync_manager_flag"]'
      )
      .then((res) => {
        $scope.dictData = $.extend($scope.dictData, res.data.value);
        $scope.dictData.taxplayer_type = $scope.dictData.taxplayer_type.filter(
          (x) => {
            return x.enumName == '一般纳税人' || x.enumName == '小规模纳税人';
          }
        );
      });
    // 获取所属区域，获取管理城市时事业部所属区域两个都要传
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    // 主管税局省（市）
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // 获取管理城市时两个都要传
    $scope.$watch('queryParam.param.regionNo', function (newVal, oldVal) {
      //重置
      if ($scope.queryParam.param.regionNo == undefined) {
        $scope.belleRegionCityList = [];
        return;
      }
      let params = {
        affiliation: $scope.queryParam.param.departmentNo,
        regionNo: $scope.queryParam.param.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    });
    // 树组件参数
    $scope.treeOptions = {
      nodeChildren: 'children',
      dirSelectable: true,
      allowDeselect: false,
      injectClasses: {
        ul: 'a1',
        li: 'a2',
        liSelected: 'a7',
        iExpanded: 'a3',
        iCollapsed: 'a4',
        iLeaf: 'a5',
        label: 'a6',
        labelSelected: 'a8',
      },
    };
    // 导入配置
    $scope.importconfig = {
      code: 'ORG_INFO',
      validate: {
        pattern: '.xlsx,.xls,.xml',
        _validate: {
          size: {
            min: 10,
            max: '10MB',
          },
          duration: {
            min: '10s',
            max: '5m',
          },
          accept: '.xlsx,.xls,.xml',
        },
      },
      callback() {
        importCb();
      },
    };
    function importCb() {
      $scope.reflashTree();
      $scope.queryOrgInfo();
    }
    $scope.expandedNodes = [];
    let expandedNodeResult = [];
    // 控制节点层级展示
    function getExpandedNode(arr) {
      if (!arr || Object.prototype.toString.call(arr).indexOf('Array') == -1)
        return;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].children && arr[i].children.length) {
          expandedNodeResult.push(arr[i]);
          //   展开所有的子节点 注释默认展开第二层
          //   getExpandedNode(arr[i].children)
        }
      }
    }

    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        invoiceFlag: '',
        orgCode: '',
        orgId: $scope.userType ? orgOwnerShip : '',
        orgName: '',
        orgStatus: '',
        orgUserName: '',
        parentOrgCode: '',
        parentOrgName: '',
        saleCreditCode: '',
        saleId: '',
        taxDiskType: '',
        treeLevelCode: '',
        belongToOrgId: orgOwnerShip,
      },
    };
    $scope.reset = function () {
      $scope.queryParam.param = {
        invoiceFlag: '',
        orgCode: '',
        orgId: $scope.userType ? $scope.orgId : '',
        orgName: '',
        orgStatus: '',
        orgUserName: '',
        parentOrgCode: '',
        parentOrgName: '',
        saleCreditCode: '',
        saleId: '',
        taxDiskType: '',
        treeLevelCode: $scope.userType ? $scope.treeLevelCode : '', // 针对非admin重置查询当前机构数据
      };
    };
    $scope.customizedConfig = {
      version: 2.1,
      queryForm: [
        {
          label: '机构名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
      ],
      table: [
        {
          label: '机构名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '有效标志',
          selected: true,
          default: true,
        },
        {
          label: '功能包',
          selected: true,
          default: true,
        },
      ],
    };

    $scope.tableDropdownConfig = [
      {
        label: '详情',
        handler(item) {
          // 优化  跳转新窗口
          let url = $state.href(
            'system.syssetting.org.detail',
            {
              orgId: item.orgId,
            },
            {
              reload: true,
            }
          );
          window.open(url, '_blank');
          //   $location
          //     .path(`/system/syssetting/org/detail/${item.orgId}`)
          //     .replace();
        },
      },
      {
        label: '编辑',
        handler(item) {
          $location.path(`/system/syssetting/org/edit/${item.orgId}`).replace();
        },
      },
      {
        label: '功能包',
        handler(item) {
          showPackageModel(item);
        },
      },
      {
        label: '删除',
        handler(item) {
          $scope.delOrg(item.orgId);
        },
        showWhile(item) {
          return item.treeLevelCode != '0';
        },
      },
    ];
    // 表头排序
    $scope.orderMap = initSortService('orgListParam');
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.queryParam.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem('orgListParam', JSON.stringify($scope.queryParam));
      $scope.queryOrgInfo();
    };
    // 查询机构信息表
    $scope.queryOrgInfo = function () {
      $scope.queryParam = sessionStorage.orgListParam
        ? JSON.parse(sessionStorage.orgListParam)
        : $scope.queryParam;
      httpRequest.post_organizationList($scope.queryParam).then((res) => {
        $scope.listData = res.data.value.list;
        // 获取后台分页数据 回写分页组件
        $scope.totalItems = res.data.value.total;
        $scope.queryParam.pageNum = res.data.value.pageNum;
        $scope.queryParam.pageSize = res.data.value.pageSize;
        $scope.selectedOrgList = []
      });
    };
    $scope.search = function () {
      //查询不需要和左侧机构树联动,默认查询所有机构
      // $scope.queryParam.param.treeLevelCode = ''
      sessionStorage.setItem('orgListParam', JSON.stringify($scope.queryParam));
      $scope.queryOrgInfo();
    };
    // $scope.search()

    $scope.totalItems = 0; // 组件初始化设置总页数
    $scope.pageChange = function () {
      sessionStorage.setItem(
        'orgListParam',
        JSON.stringify({
          orderMap: $scope.queryParam.orderMap,
          pageNum: $scope.queryParam.pageNum,
          pageSize: $scope.queryParam.pageSize,
          param: sessionStorage.orgListParam
            ? JSON.parse(sessionStorage.orgListParam).param
            : {
              invoiceFlag: '',
              orgCode: '',
              orgId: $scope.userType ? orgOwnerShip : '',
              orgName: '',
              orgStatus: '',
              orgUserName: '',
              parentOrgCode: '',
              parentOrgName: '',
              saleCreditCode: '',
              saleId: '',
              taxDiskType: '',
              treeLevelCode: '',
              belongToOrgId: orgOwnerShip,
            },
        })
      );
      $scope.queryOrgInfo();
    };

    $scope.reflashTree = function () {
      utils.loading('正在加载···');
      httpRequest.get_organization($scope.userTypeOrgId).then((res) => {
        // 缓存原始列表
        const resVal = res.data.value;
        utils.loaded();
        $scope.orgList = $.extend(true, {}, resVal);
        // 机构树
        if ($scope.userType) {
          $scope.orgTree = buildTree(resVal, $scope.parentOrgId);
          //过滤出平级数据
          $scope.peerDataTree = peerDataHandle(resVal, $scope.parentOrgId);
          // 处理存在orgTree和peerDataTree有相同的数据 如果有
          if ($scope.peerDataTree.length > 0) {
            $scope.orgTree = handlerSameData(
              $scope.orgTree,
              $scope.peerDataTree[0].orgId
            );
          }
        } else {
          $scope.orgTree = buildTree(resVal, -1);
        }
        $scope.defaultNode = $scope.orgTree[0];
        $scope.orgId = $scope.defaultNode.orgId;
        getExpandedNode($scope.orgTree);
        $scope.expandedNodes = expandedNodeResult;
        $scope.showSelected($scope.defaultNode, true);
      });
    };
    $scope.reflashTree();
    // 适配树组件数据结构
    function buildTree(list, rootId) {
      function recursion(data, pid) {
        const result = [];
        let temp;
        for (const i in data) {
          if (data[i].parentOrgId == pid) {
            result.push(data[i]);
            temp = recursion(data, data[i].orgId);
            if (temp.length > 0) {
              data[i].children = temp;
            }
          }
        }
        return result;
      }
      return recursion(list, rootId);
    }
    // 返回平级数据树
    function peerDataHandle(arrList, currentPOrgId) {
      let peerDataList = arrList.filter((item) => {
        return item.notTreeStructure == false;
      });
      if (peerDataList.length == arrList.length) {
        return [];
      } else {
        let treeLevelCode = peerDataList[0].treeLevelCode;
        let treeLevelArr = treeLevelCode.split('_').map(Number);
        let parentOrgIdArr = treeLevelArr.filter((item, index) => {
          return item !== 0;
        });
        let peerDataTree = buildTree(peerDataList, parentOrgIdArr[0]);
        return peerDataTree;
      }
    }
    // 判断是否有重复数据
    function handlerSameData(allOrgTree, peerDataTreeOrgId) {
      if (allOrgTree[0].hasOwnProperty('children')) {
        recursionChild(
          allOrgTree,
          peerDataTreeOrgId,
          (item, peerDataTreeOrgId) => {
            if (item.orgId == peerDataTreeOrgId) {
              $scope.newTree = allOrgTree;
            }
          }
        );
      } else {
        $scope.newTree = allOrgTree.concat($scope.peerDataTree);
      }
      return $scope.newTree;
    }
    // 递归树
    var recursionChild = function (allOrgTree, peerDataTreeOrgId, cb) {
      for (const i in allOrgTree) {
        cb(allOrgTree[i], peerDataTreeOrgId);
        if (allOrgTree[i].children) {
          recursionChild(allOrgTree[i].children, peerDataTreeOrgId, cb);
        }
      }
    };
    $scope.add_org_disabled = false;
    // 点击查询机构信息表
    $scope.showSelected = function showSelected(node, flag) {
      // 优化 不存储整个对象node，只存储需要的字段
      let obj = {
        orgId: node.orgId,
        treeLevelCode: node.treeLevelCode,
        orgName: node.orgName,
      };
      if (node) {
        sessionStorage.setItem('selectedOrg', JSON.stringify(obj));
      }
      $scope.currentOrgItem = node;
      $scope.queryParam.param.treeLevelCode = node.treeLevelCode;
      $scope.treeLevelCode = node.treeLevelCode;
      $scope.orgId = node.orgId;
      if ($scope.userType) {
        $scope.queryParam.param.orgId = node.orgId;
      }
      if (!$scope.userType || $scope.orgId !== orgOwnerShip) {
        delete $scope.queryParam.param.belongToOrgId;
      }
      // // 初始化显示所有数据 flag判断 当前选择的机构是所属机构
      // if ($scope.userType && flag) {
      //   $scope.queryParam.param.belongToOrgId = orgOwnerShip;
      // } else {
      //   delete $scope.queryParam.param.belongToOrgId;
      // }
      sessionStorage.setItem('orgListParam', JSON.stringify($scope.queryParam));
      node.treeLevelCode.split('_').length === 5
        ? ($scope.add_org_disabled = true)
        : ($scope.add_org_disabled = false);
      // 设置选中的表
      $scope.queryOrgInfo();
    };

    // 删除多个确认弹窗
    $scope.delOrg = function (id) {
      sweetalert.confirm('删除提醒', '确定删除当前机构?').then(
        () => {
          httpRequest.get_removeByOrgId(id).then((res) => {
            logger.logSuccess('机构删除成功');
            $scope.queryOrgInfo();
            $scope.reflashTree();
          });
        },
        () => { }
      );
    };
    $scope.toAddPage = function () {
      $location.path(`/system/syssetting/org/add/`).replace();
    };

    function showPackageModel(item) {
      httpRequest.get_PackOfTenantOrOrg(item.orgId).then((res) => {
        const packIdList = res.data.value.map((x) => x.packId);
        const modalInstance = $uibModal.open({
          template: packageModalPage,
          controller: 'packageModalCtrl',
          backdrop: 'static',
          openedClass: 'mod-modal-chooseperson mod-modal mod-modal-lg',
          resolve: {
            items1() {
              return {
                selectedFunList: packIdList,
              };
            },
          },
        });
        modalInstance.result.then((resu) => {
          if (resu.selectedList) {
            let param = {
              orgId: item.orgId,
              packIdList: resu.selectedList,
            };
            httpRequest
              .post_updatePacksOfOrg(param, '功能包修改成功')
              .then(() => {
                $scope.queryOrgInfo();
              });
          }
        });
      });
    }
    // 导出
    $scope.exportExel = function exportExel() {
      let url = `${host.etcloud
        }ems/sysOrganization/exportOrgToXLS?accessToken=${localStorage.getItem(
          'id_token'
        )}`;
      utils.org_export(url, $scope.queryParam.param)
    };
    $scope.exportTaxAccount = function () {
      let _url = `${host.etcloudOvat
        }tax4/ovatTax4Drawer/downloadDrawerUpdateTemplate?accessToken=${localStorage.getItem(
          'id_token'
        )}`
      utils.file_download(
        _url,
        {updateExportType:'taxAccountAll'},
        '', //type
        'POST',
        'blob',
        '',
        false
      )

    }
    // 机构更新导入
    $scope.agencyUpdateImport = function agencyUpdateImport(file, errFiles) {
      if (file == null && errFiles.length >= 1) {
        logger.logError(
          '文件类型错误，文件大小不超过20MB，只支持.xlsx,.xls格式文件导入'
        );
        return;
      }
      if (file) {
        file.upload = Upload.upload({
          url: `${host.etcloud}dl/dlTaskService/import_ORG_UPDATE_IMPORT`,
          data: {
            importFile: file,
            code: 'ORG_UPDATE_IMPORT',
          },
        });
        // 文件上传
        // loading动画
        const importinglayer = layer.msg('玩命上传中，请耐心等待', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        });
        file.upload.then(
          (res) => {
            $timeout(() => {
              if (!res.data.success) {
                layer.close(importinglayer);
                return logger.logError(res.data.message || '上传失败');
              }
              if (res.data.value.sourceCount === 0) {
                layer.close(importinglayer);
                return logger.logTips('导入数据为空！', 'warn');
              }
              const { batchNo, sourceCount, errorCount } = res.data.value;
              // 结果弹框
              // if (res.data.value.errorCount > 0) {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: 1,
                  pageSize: 10,
                  param: res.data.value.batchNo,
                })
                .then((res1) => {
                  layer.close(importinglayer);
                  $scope.importResultModal({
                    batchNo,
                    sourceCount,
                    successCount: sourceCount - errorCount,
                    errorCount,
                    data: res1.data.value,
                  });
                  $scope.queryInfo();
                });
            });
          },
          (response) => { }
        );
      }
    };
    // 导入结果弹窗
    $scope.importResultModal = function (modalData) {
      const modalInstance = $uibModal.open({
        template: importResult,
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.modalData = items1;
            $scope.list = items1.data.list;
            console.log($scope.modalData);
            $scope.pageOptions = {
              // 分页器
              totalItems: $scope.modalData.data.total,
              currentPage: ++$scope.modalData.data.prePage,
              maxSize: $scope.modalData.data.pageSize,
            };
            // 关闭
            $scope.ok = () => {
              $uibModalInstance.close();
            };
            // 分页查询
            $scope.pageChanged = () => {
              queryList();
            };
            function queryList() {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: $scope.pageOptions.currentPage,
                  pageSize: $scope.pageOptions.maxSize,
                  param: $scope.modalData.batchNo,
                })
                .then((res) => {
                  $scope.list = res.data.value.list;
                  $scope.pageOptions = {
                    // 分页器
                    totalItems: res.data.value.total,
                    currentPage: ++res.data.value.prePage,
                    maxSize: res.data.value.pageSize,
                  };
                });
            }
            // 导出错误详情
            $scope.downBatchInfo = function () {
              window.open(
                `${host.etcloudIvatApp}dl/dlTaskService/downBatchInfoDetail?batchNo=${$scope.modalData.batchNo}&accessToken=${localStorage.id_token}`
              );
            };
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal-importexcel',
        windowClass: 'mod-modal mod-modal-lg',
        bindToController: true,
        resolve: {
          items1() {
            return modalData;
          },
        },
      });
      modalInstance.result.then(
        () => {
          $scope.queryOrgInfo();
        },
        () => { }
      );
    };

    // 模板下载
    $scope.downloadExcel = function () {
      // let downloadUrl = 'ems/sysOrganization/exportToExcel?'
      let downloadUrl = `${host.etcloud
        }ems/sysOrganization/exportToExcel?accessToken=${localStorage.getItem(
          'id_token'
        )}`;
      utils.org_export(downloadUrl, $scope.queryParam.param)
      // Object.keys($scope.queryParam.param).forEach((key) => {
      //     downloadUrl += `${key}=${encodeURI($scope.queryParam.param[key])}&`
      // })
      // window.open(`${host.etcloud}${downloadUrl}&accessToken=${$scope.idToken}`)
    };
    $scope.synchronousManagementPlatform = function () {
      if (!$scope.selectedOrgList.length) return logger.logError('请选择数据后再操作')
      let orgIdList = $scope.selectedOrgList.map((x) => x.orgId)
      httpRequest.post_syncOrganization(orgIdList, '同步管理平台成功').then((res) => {

      })
    }
    $scope.synchronousArchiveOrg = function(){
      utils.loading()
      httpRequest.post_syncArchiveOrg().then(res=>{
        utils.loaded()
        logger.logSuccess('同步档案机构完成')
      })
    }
    $scope.cshOrgs = function(){
      utils.loading()
      httpRequest.post_syncBelleAllOrg().then(res=>{
        utils.loaded()
        logger.logSuccess('初始化机构完成')
      })
    }
  }
}
orgListCtrl.$inject = [
  '$scope',
  '$uibModal',
  'logger',
  'httpRequest',
  '$location',
  'initSortService',
  'sweetalert',
  '$rootScope',
  '$state',
  'Upload',
  '$timeout',
];
export default orgListCtrl;



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/org/orgListCtrl.js